import { v4 as uuid } from "uuid";
import { RootState } from "@/store/store";
import { ReservationRecommendation } from "@/services/cloudchipr.api";
import { reservationsRecommendationsDataSelector } from "@/store/commitments/selectors/recommendations/reservations/reservationsRecommendationsDataSelector";

export const reservationsRecommendationsGridDataSelector = (
  state: RootState,
): (ReservationRecommendation & { id: string })[] | undefined => {
  const response = reservationsRecommendationsDataSelector(state);

  return response?.map((rec) => ({ ...rec, id: uuid() }));
};
